import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
    getRawSessionStorage(key: string): string {
        return sessionStorage.getItem(key) || '';
    }

    getFromSessionStorage(key: string): string {
        return this.getRawSessionStorage(key).trim().replace(/"/g, '') || '';
    }
}
